<div class="padding">
  <form [formGroup]="lienDetails">
    <app-term [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!" [errors$]="observableErrors$" [order]="order" [isDisabled]="isDisabled"></app-term>

    @if (uiConfiguration.lienDetailsConfiguration?.showAmount) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.amount' | transloco }}</mat-label>
            <input matInput data-testid="amount-field" [placeholder]="'common.labels.amount' | transloco" [formControlName]="'amount'" type="number">
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['amount']"
          [message]="amountError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showPerfectionInAnotherJurisdiction ||
      uiConfiguration.lienDetailsConfiguration?.showPurchaseMoneySecurityInterest) {
      <div class="flex-container flex-item padding-top">
        @if (uiConfiguration.lienDetailsConfiguration?.showPerfectionInAnotherJurisdiction) {
          <div class="validated-form-field-container flex-container">
            <mat-checkbox class="flex-item" [formControlName]="'perfectionInAnotherJurisdiction'" data-testid="perfection-checkbox">
              {{ 'orders.perfectionInAnotherJurisdiction' | transloco }}
            </mat-checkbox>
            <lib-error-bubble [control]="lienDetails.controls['perfectionInAnotherJurisdiction']"
            [message]="perfectionInAnotherJurisdictionError$"></lib-error-bubble>
          </div>
        }
        @if (uiConfiguration.lienDetailsConfiguration?.showPurchaseMoneySecurityInterest) {
          <div class="validated-form-field-container flex-container">
            <mat-checkbox class="flex-item" [formControlName]="'purchaseMoneySecurityInterest'"
              data-testid="security-interest-checkbox">
              {{ 'orders.purchaseMoneySecurityInterest' | transloco }}
            </mat-checkbox>
            <lib-error-bubble [control]="lienDetails.controls['purchaseMoneySecurityInterest']"
            [message]="purchaseMoneySecurityInterestError$"></lib-error-bubble>
          </div>
        }
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showTrustIndenture ||
      uiConfiguration.lienDetailsConfiguration?.showReceiverAppointment) {
      <div class="flex-container flex-item padding-top">
        @if (uiConfiguration.lienDetailsConfiguration?.showTrustIndenture) {
          <div  class="validated-form-field-container flex-container">
            <mat-checkbox class="flex-item" [formControlName]="'trustIndenture'" data-testid="trust-indenture-checkbox">
              {{ 'orders.trustIndenture' | transloco }}
            </mat-checkbox>
            <lib-error-bubble [control]="lienDetails.controls['trustIndenture']"
            [message]="trustIndentureError$"></lib-error-bubble>
          </div>
        }
        @if (uiConfiguration.lienDetailsConfiguration?.showReceiverAppointment) {
          <div  class="validated-form-field-container flex-container">
            <mat-checkbox class="flex-item" [formControlName]="'receiverAppointment'" data-testid="receiver-appointment-checkbox">
              {{ 'orders.receiverAppointment' | transloco }}
            </mat-checkbox>
            <lib-error-bubble [control]="lienDetails.controls['receiverAppointment']"
            [message]="receiverAppointmentError$"></lib-error-bubble>
          </div>
        }
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showHasDebtorAcknowledged) {
      <div class="flex-container flex-item padding-top">
        <div class="validated-form-field-container flex-container">
          <mat-checkbox class="flex-item" formControlName="hasDebtorAcknowledged" data-testid="debtor-acknowledged-checkbox">
            {{ 'orders.debtorHasAcknowledgedTheDebt' | transloco }}
          </mat-checkbox>
          <lib-error-bubble [control]="lienDetails.controls['hasDebtorAcknowledged']"
          [message]="hasDebtorAcknowledgedError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showStillHavePossession) {
      <div class="flex-container flex-item padding-top">
        <div class="validated-form-field-container flex-container">
          <mat-checkbox class="flex-item" formControlName="stillHavePossession" data-testid="possession-checkbox">
            {{ 'orders.stillHavePossession' | transloco }}
          </mat-checkbox>
          <lib-error-bubble [control]="lienDetails.controls['stillHavePossession']"
          [message]="stillHavePossessionError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showSurrenderDate) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'orders.surrenderDate' | transloco }}</mat-label>
            <input matInput [matDatepicker]="surrenderDate" data-testid="surrender-date-field" formControlName="surrenderDate"
              [placeholder]="'common.labels.yyyyMmDd' | transloco">
            <mat-datepicker-toggle matSuffix [for]="surrenderDate"></mat-datepicker-toggle>
            <mat-datepicker #surrenderDate></mat-datepicker>
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.get('surrenderDate')!"
          [message]="surrenderDateError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showServiceLastRendered) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'orders.serviceLastRendered' | transloco }}</mat-label>
            <input matInput [matDatepicker]="serviceLastRendered" data-testid="service-last-rendered-date-field" formControlName="serviceLastRendered"
              [placeholder]="'common.labels.yyyyMmDd' | transloco">
            <mat-datepicker-toggle matSuffix [for]="serviceLastRendered"></mat-datepicker-toggle>
            <mat-datepicker #serviceLastRendered></mat-datepicker>
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.get('serviceLastRendered')!"
          [message]="serviceLastRenderedError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showNatureOfServiceRendered) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'orders.natureOfServiceRendered' | transloco }}</mat-label>
            <textarea matInput data-testid="nature-of-service-rendered-field" formControlName="natureOfServiceRendered"></textarea>
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['natureOfServiceRendered']"
          [message]="natureOfServiceRenderedError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showAdditionalInformation) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'orders.additionalInformation' | transloco }}</mat-label>
            <textarea matInput data-testid="additional-information-field" [formControlName]="'additionalInformation'"
            [placeholder]="'orders.additionalInformation2' | transloco"></textarea>
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['additionalInformation']"
          [message]="additionalInformationError$"></lib-error-bubble>
        </div>
      </div>
    }
  </form>
</div>